import React from 'react';
import useStyles from './styles';
import SummaryTable from './summaryTable';
import { observer } from 'mobx-react-lite';
import { Button, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
export const AdditionalChargesCreditsModal = observer(_ref => {
  let isOpenExternal = _ref.isOpenExternal,
    handleModalCloseExt = _ref.handleModalCloseExt,
    absorbAdjustments = _ref.absorbAdjustments,
    includeAdjustments = _ref.includeAdjustments,
    correctionSummary = _ref.correctionSummary,
    isExcluded = _ref.isExcluded,
    showDetails = _ref.showDetails;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  let residentSummaryEntries = [...(correctionSummary === null || correctionSummary === void 0 ? void 0 : correctionSummary.residentSummaryEntries)] || [];
  residentSummaryEntries.sort((a, b) => a.unitName.localeCompare(b.unitName));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    trigger: null,
    variant: 'large',
    isOpen: isOpenExternal,
    handleClose: handleModalCloseExt,
    title: t('Additional charges/credits')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chipWrapper
  }, /*#__PURE__*/React.createElement(Chip, {
    label: "".concat(isExcluded ? "You absorb adjustments. Under-billed residents won't be charged extra, and over-billed residents won't get extra credit." : 'Your retroactive actions caused billing errors. Additional charges/credits have been added in the current cycle for residents affected.'),
    variant: "".concat(isExcluded ? 'inactive' : 'warning')
  })), /*#__PURE__*/React.createElement(SummaryTable, {
    isExcluded: isExcluded,
    residentSummaryEntries: residentSummaryEntries
  }), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalCloseExt
  }, "Cancel")), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => showDetails()
  }, "View details")), !isExcluded && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => absorbAdjustments()
  }, "Absorb adjustments")), isExcluded && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: async () => {
      await includeAdjustments();
    }
  }, "Include adjustments back"))))));
});